import SignaturePad, { SignaturePadBlock } from './components/SignaturePadContainer';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, signaturePadCategory } = opts;
  SignaturePadBlock(bm, signaturePadCategory, labels.signaturePad, types.signaturePad);
  SignaturePad(dc, labels.signaturePad, types.signaturePad, opts);
};
